// src/types/calendar.ts
// 日曆相關的型別定義

import type { Task } from './task';

/**
 * 放置模式狀態
 * - idle: 未進入放置模式
 * - selecting: 已選取任務，等待用戶選擇時段
 * - previewing: 已選擇時段，顯示預覽並等待確認
 */
export type PlacementModeState = 'idle' | 'selecting' | 'previewing';

/**
 * 放置模式數據
 * 包含放置流程中需要追蹤的所有資訊
 */
export interface PlacementModeData {
  /** 當前放置模式狀態 */
  state: PlacementModeState;

  /** 被選取的任務（步驟 1 選取後填入） */
  selectedTask: Task | null;

  /** 預覽的時段資訊（步驟 2 選擇時段後填入） */
  previewSlot: {
    /** 開始時間 */
    startTime: Date;
    /** 結束時間 */
    endTime: Date;
  } | null;
}

/**
 * 初始化放置模式數據
 */
export const initialPlacementModeData: PlacementModeData = {
  state: 'idle',
  selectedTask: null,
  previewSlot: null,
};
